import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import 'moment/locale/id';
import { SuratJalanBateraiRestService } from '../surat-jalan-baterai-rest.service';
import Swal from 'sweetalert2';
import { APP_CONST } from '../../../app.const';
import { SuratJalanBateraiListComponent } from '../list/surat-jalan-baterai-list.component';
import { AuthenticationService } from '../../../libraries/libraries.module';

@Component({
  selector: 'app-draft-modal',
  templateUrl: 'draft-modal.component.html',
  styleUrls: ['../surat-jalan-baterai-module.scss']
})
export class DraftModalComponent {
  @ViewChild('sgbSearchInput') sgbSearchInput: ElementRef;

  @Input() suratJalanBaterai: any;
  @Input() ticketType: string;

  isModalOpen: boolean = false;
  customerData: any = null; // To store fetched customer data
  selectedCustomer: any = null;
  uploadEndpoint = APP_CONST.API_FILE;
  inputBatteryCodeType: string = 'manual';
  dealerAddress: any = [];
  isDealerAddressLoading: boolean = false;
  sjbType: any = [];
  isSjbTypeLoading: boolean = false;
  today: string = new Date().toISOString().split('T')[0];
  formStep: number = 1;
  isCustomerDataLoading: boolean = false;
  isLoading: boolean = false;
  motorcycleList: any;

  newBatteryCode: string = '';
  batteryCodes: string[] = [];
  customerBatteryCodes: string[] = [];
  photoPreviewModal: boolean = false;
  photoPreviewTitle: string = '';
  selectedSgb: { id: number; name: string } = { id: 0, name: '' };
  sgbList: { id: number; name: string }[] = [];
  sgbLoading: boolean = false;
  searchSgb: string = '';
  searchDebounceTimeout: any;
  showSgbDropdown: boolean = false;

  get filteredSuratJalanTypes(): { name: string; value: string }[] {
    if (this.ticketType === 'baterai_rusak' && this.isDealership()) {
      return this.sjbType.filter(t => t.value === 'return' || t.value === 'permintaan_buka_pintu');
    } else if (this.ticketType === 'request_baru') {
      return this.sjbType.filter(t => t.value === 'pengiriman' || t.value === 'permintaan');
    } else {
      return this.sjbType.filter(t => t.value === 'return' || t.value === 'pengiriman');
    }
  }

  isDealership(): boolean {
    return this._authentication?.user?.role?.name?.toLowerCase?.() === 'dealership';
  }

  addBatteryCode(): void {
    const trimmed = this.newBatteryCode.trim();
    if (trimmed && !this.batteryCodes.includes(trimmed)) {
      this.batteryCodes.push(trimmed);
      this.newBatteryCode = '';
    }
  }

  removeBatteryCode(index: number): void {
    this.batteryCodes.splice(index, 1);
  }

  getStbList(name?: string) {
    this.sgbLoading = true;

    if (name && name.trim().length < 3) {
      this.sgbLoading = false;
      return;
    }

    this._SuratJalanBateraiRest.getStbList(name).subscribe({
      next: (response: any) => {
        const data = response?.data || [];
        this.sgbList = data;
        this.sgbLoading = false;

        // Focus the input after API call completes
        setTimeout(() => {
          if (this.sgbSearchInput && this.sgbSearchInput.nativeElement) {
            this.sgbSearchInput.nativeElement.focus();
          }
        }, 100);
      },
      error: err => {
        this.sgbLoading = false;

        // Focus the input even on error
        setTimeout(() => {
          if (this.sgbSearchInput && this.sgbSearchInput.nativeElement) {
            this.sgbSearchInput.nativeElement.focus();
          }
        }, 100);
      }
    });
  }

  filterSgbList() {
    // Clear existing timeout
    if (this.searchDebounceTimeout) {
      clearTimeout(this.searchDebounceTimeout);
    }

    // Set new timeout for 1 second
    this.searchDebounceTimeout = setTimeout(() => {
      this.getStbList(this.searchSgb);
      this.showSgbDropdown = true;
    }, 1000);
  }

  selectSgb(item: { id: number; name: string }) {
    this.formDataBateraiRusak.sgb = {
      id: item.id.toString(),
      name: item.name
    };
    this.searchSgb = item.name;
    this.showSgbDropdown = false;
    this.selectedSgb = item;
  }

  hideSgbDropdown() {
    // Add a small delay to allow click events to process
    setTimeout(() => {
      this.showSgbDropdown = false;
    }, 200);
  }

  onSgbChange() {
    const sgbId = this.formDataBateraiRusak.sgb.id;
    const sgbName = this.sgbList.find(item => item.id === Number(sgbId))?.name;

    // Find the selected SGB from the list
    this.selectedSgb = this.sgbList.find(item => item.id === Number(sgbId) && item.name === sgbName);

    if (!this.selectedSgb) return;

    // Update the form data with the selected SGB information
    this.formDataBateraiRusak.sgb = {
      id: this.selectedSgb.id.toString(),
      name: this.selectedSgb.name
    };
  }

  onSuratJalanTypeChange() {
    if (this.formDataBateraiRusak.suratJalanType === 'permintaan_buka_pintu') {
      this.formDataBateraiRusak.finalLocation = 'Customer Service';
      this.formDataBateraiRusak.finalAddress = 'Customer Service Volta Indonesia';
    }
  }

  getCustomerBatteryCodes(motorcycleNumber: string): { label: string; value: string }[] {
    const customer = this.suratJalanBaterai.customers.find(c => c.motorcycleNumber === motorcycleNumber);
    return customer ? customer.batteryCode.map(code => ({ label: code, value: code })) : [];
  }

  addCustomer() {
    this.formDataBateraiRusak.customers.push({
      ktp: '',
      phoneNumber: '',
      name: '',
      motorcycleNumber: '',
      chassisNumber: '',
      batteryCode: ['']
    });
  }

  removeCustomer(index: number) {
    this.formDataBateraiRusak.customers.splice(index, 1);
  }

  onMotorcycleNumberChange(index: number) {
    this.selectedCustomer = this.customerData[index];
  }

  formDataBateraiRusak = {
    noTicket: '',
    noSuratJalan: '',
    ticketType: '',
    suratJalanType: '',
    startingLocation: '',
    startingAddress: '',
    finalLocation: '',
    finalAddress: '',
    description: '',
    dealerPhoneNumber: '',
    customer: {
      ktp: '',
      phoneNumber: '',
      name: '',
      motorcycleNumber: '',
      chassisNumber: '',
      batteryCode: [''],
      oldBatteryCode: '',
      newBatteryCode: ''
    },
    shippingInformation: {
      type: '',
      shippingNumber: '',
      reimburseAmount: 0,
      shippingProof: '',
      shippingProofUrl: ''
    },
    customers: [
      {
        ktp: '',
        phoneNumber: '',
        name: '',
        motorcycleNumber: '',
        chassisNumber: '',
        batteryCode: ['']
      }
    ],
    sgb: {
      id: '',
      name: ''
    }
  };

  formDataRequestBaru = {
    noTicket: '',
    noSuratJalan: '',
    ticketType: '',
    suratJalanType: '',
    startingLocation: '',
    startingAddress: '',
    finalLocation: '',
    finalAddress: '',
    description: '',
    excelFile: null,
    fileKodeBateraiName: '',
    inputMode: '',
    requestTotal: null,
    shippingInformation: {
      type: '',
      shippingNumber: '',
      reimburseAmount: 0,
      shippingProof: '',
      shippingProofUrl: ''
    }
  };

  constructor(
    private _SuratJalanBateraiRest: SuratJalanBateraiRestService,
    public _suratJalanBateraiListComponent: SuratJalanBateraiListComponent,
    private _authentication: AuthenticationService,
    private el: ElementRef
  ) {}

  resetFormData() {
    this.formDataBateraiRusak = {
      noTicket: this.suratJalanBaterai.noTicket,
      noSuratJalan: this.suratJalanBaterai.noSuratJalan,
      ticketType: 'baterai_rusak',
      suratJalanType: this.suratJalanBaterai.suratJalanType,
      startingLocation: this.suratJalanBaterai.startingLocation,
      startingAddress: this.suratJalanBaterai.startingAddress,
      finalLocation: this.suratJalanBaterai.finalLocation,
      finalAddress: this.suratJalanBaterai.finalAddress,
      description: this.suratJalanBaterai.description,
      dealerPhoneNumber: this.suratJalanBaterai.dealerPhoneNumber,
      customer: {
        ktp: this.suratJalanBaterai?.customer?.ktp,
        phoneNumber: this.suratJalanBaterai?.customer?.phoneNumber,
        name: this.suratJalanBaterai?.customer?.name,
        motorcycleNumber: this.suratJalanBaterai?.customer?.motorcycleNumber,
        chassisNumber: this.suratJalanBaterai?.customer?.chassisNumber,
        batteryCode: this.suratJalanBaterai?.customer?.batteryCode || [''],
        oldBatteryCode: this.suratJalanBaterai?.customer?.oldBatteryCode,
        newBatteryCode: this.suratJalanBaterai?.customer?.newBatteryCode
      },
      shippingInformation: {
        type: this.suratJalanBaterai?.shippingInformation?.type,
        shippingNumber: this.suratJalanBaterai?.shippingInformation?.shippingNumber,
        reimburseAmount: this.suratJalanBaterai?.shippingInformation?.reimburseAmount,
        shippingProof: this.suratJalanBaterai?.shippingInformation?.shippingProof,
        shippingProofUrl: this.suratJalanBaterai?.shippingInformation?.shippingProofUrl
      },
      customers: this.suratJalanBaterai?.customers || [
        {
          ktp: '',
          phoneNumber: '',
          name: '',
          motorcycleNumber: '',
          chassisNumber: '',
          batteryCode: ['']
        }
      ],
      sgb: this.suratJalanBaterai?.sgb || {
        id: '',
        name: ''
      }
    };

    this.formDataRequestBaru = {
      noTicket: this.suratJalanBaterai.noTicket,
      noSuratJalan: this.suratJalanBaterai.noSuratJalan,
      ticketType: 'request_baru',
      suratJalanType: this.suratJalanBaterai.suratJalanType,
      startingLocation: this.suratJalanBaterai.startingLocation,
      startingAddress: this.suratJalanBaterai.startingAddress,
      finalLocation: this.suratJalanBaterai.finalLocation,
      finalAddress: this.suratJalanBaterai.finalAddress,
      description: this.suratJalanBaterai.description,
      inputMode: this.inputBatteryCodeType,
      excelFile: null,
      fileKodeBateraiName: '',
      requestTotal: this.suratJalanBaterai?.requestTotal || null,
      shippingInformation: {
        type: this.suratJalanBaterai?.shippingInformation?.type,
        shippingNumber: this.suratJalanBaterai?.shippingInformation?.shippingNumber,
        reimburseAmount: this.suratJalanBaterai?.shippingInformation?.reimburseAmount,
        shippingProof: this.suratJalanBaterai?.shippingInformation?.shippingProof,
        shippingProofUrl: this.suratJalanBaterai?.shippingInformation?.shippingProofUrl
      }
    };

    this.batteryCodes = this.suratJalanBaterai.batteries;

    // Initialize SGB search field if SGB data exists
    if (this.suratJalanBaterai?.sgb?.name) {
      this.searchSgb = this.suratJalanBaterai.sgb.name;
    }
  }

  openModal(suratJalanBaterai: any) {
    this.isModalOpen = true;
    this.customerData = null; // Reset customer data when modal is opened
    this.suratJalanBaterai = suratJalanBaterai;
    this.getDealerAddress();
    this.getSjbType();
    this.resetFormData();
    this.isDealership();
    this.customerBatteryCodes =
      suratJalanBaterai.customer?.batteryCode?.map((code: string) => ({ label: code, value: code })) || [];
    this.getStbList(); // Initialize SGB list
    console.log('suratJalanBaterai', this.suratJalanBaterai);
  }

  closeModal() {
    this.isModalOpen = false;
    this.resetFormData();

    // Clear any pending search timeout
    if (this.searchDebounceTimeout) {
      clearTimeout(this.searchDebounceTimeout);
      this.searchDebounceTimeout = null;
    }

    // Reset SGB related properties
    this.searchSgb = '';
    this.showSgbDropdown = false;
    this.sgbList = [];
  }

  onFileChange(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target.files && target.files.length > 0) {
      // const reader = new FileReader();
      const file = target.files[0];
      // const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);

      // reader.onload = () => {
      // this.invoiceImageBase64 = reader.result as string;
      // };

      // reader.readAsDataURL(file);

      this.formDataRequestBaru.excelFile = file;
      this.formDataRequestBaru.fileKodeBateraiName = file.name;

      // this.selectedFileName = file.name;
      // this.fileSize = fileSizeMB + 'MB';
    }
  }

  prevStep() {
    this.formStep--;
  }

  nextStep() {
    if (!this.customFormValidation()) {
      return;
    }

    if (
      this.formStep === 1 &&
      this.ticketType === 'baterai_rusak' &&
      this.formDataBateraiRusak.suratJalanType === 'permintaan_buka_pintu' &&
      (!this.formDataBateraiRusak.customers || this.formDataBateraiRusak.customers.length === 0)
    ) {
      this.addCustomer();
    }

    this.formStep++;
  }

  async openPhotoPreview(file, title) {
    this.photoPreviewModal = true;
    this.photoPreviewTitle = title;

    setTimeout(() => {
      const photoPreview = this.el.nativeElement.querySelector('#js-photoPreview');
      if (photoPreview) {
        photoPreview.src = file;
        photoPreview.href = file;
      } else {
        console.error('photoPreview element not found');
      }
    }, 0); // Wait for the DOM update
  }

  closePhotoPreviewModal() {
    this.photoPreviewModal = false;
  }

  getDealerAddress() {
    this.isDealerAddressLoading = true;

    this._SuratJalanBateraiRest.getDealerAddress().subscribe({
      next: (response: any) => {
        this.dealerAddress = response.data;
        this.isDealerAddressLoading = false;
      },
      error: err => {
        this.isDealerAddressLoading = false;
      }
    });
  }

  getCustomerData(ktp: string, customerIndex?: number) {
    this.isCustomerDataLoading = true;

    this._SuratJalanBateraiRest.getCustomerData(ktp).subscribe({
      next: (response: any) => {
        this.customerData = response.data;

        if (this.formDataBateraiRusak.suratJalanType === 'permintaan_buka_pintu' && typeof customerIndex === 'number') {
          // Update specific customer in the customers array
          this.formDataBateraiRusak.customers[customerIndex] = {
            ...this.formDataBateraiRusak.customers[customerIndex],
            ktp: response.data.id_card,
            phoneNumber: response.data.phone_number,
            name: response.data.name
          };

          // Optional: set motorcycle list for dropdown
          this.motorcycleList = response.data.motorcycle;

          // Optional: set first motorcycle if available
          if (this.motorcycleList.length > 0) {
            const selectedMotor = this.motorcycleList[0];
            this.formDataBateraiRusak.customers[customerIndex].motorcycleNumber = selectedMotor.motorcycle_number;
            this.formDataBateraiRusak.customers[customerIndex].chassisNumber = selectedMotor.chassis_number;
            this.formDataBateraiRusak.customers[customerIndex].batteryCode = selectedMotor.batteries?.map(
              b => b.battery_code
            ) || [''];
            this.customerBatteryCodes =
              selectedMotor.batteries?.map(b => ({
                label: b.battery_code,
                value: b.battery_code
              })) || [];
          }
        } else {
          // Handle single customer case
          this.formDataBateraiRusak.customer.ktp = response.data.id_card;
          this.formDataBateraiRusak.customer.phoneNumber = response.data.phone_number;
          this.formDataBateraiRusak.customer.name = response.data.name;

          // Optional: set motorcycle list untuk dropdown
          this.motorcycleList = response.data.motorcycle;

          // Optional: kalau lo mau langsung set motor pertama
          if (this.motorcycleList.length > 0) {
            const selectedMotor = this.motorcycleList[0];
            this.formDataBateraiRusak.customer.motorcycleNumber = selectedMotor.motorcycle_number;
            this.formDataBateraiRusak.customer.chassisNumber = selectedMotor.chassis_number;
            this.formDataBateraiRusak.customer.batteryCode = selectedMotor.batteries?.map(b => b.battery_code) || [''];
            this.customerBatteryCodes =
              selectedMotor.batteries?.map(b => ({
                label: b.battery_code,
                value: b.battery_code
              })) || [];
          }
        }

        this.isCustomerDataLoading = false;
        Swal.fire('Success', 'Data customer ditemukan', 'success');
      },
      error: err => {
        this.isCustomerDataLoading = false;
        Swal.fire('Error', 'No. KTP customer tidak ditemukan', 'error');
      }
    });
  }

  getSjbType() {
    this.isSjbTypeLoading = true;

    this._SuratJalanBateraiRest.getSjbType().subscribe({
      next: (response: any) => {
        this.sjbType = response;
        this.isSjbTypeLoading = false;
      },
      error: err => {
        console.error(err);
        this.isSjbTypeLoading = false;
      }
    });
  }

  convertToFormData(data: any): FormData {
    const formData = new FormData();

    for (const key in data) {
      if (!data.hasOwnProperty(key)) continue;
      const value = data[key];

      if (value instanceof File) {
        formData.append(key, value);
      } else if (Array.isArray(value)) {
        value.forEach(item => {
          formData.append(`${key}[]`, item);
        });
      } else if (typeof value === 'object' && value !== null) {
        // Instead of flattening, stringify object
        formData.append(key, JSON.stringify(value));
      } else if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    }

    return formData;
  }

  onLocationChange(type: string, locationType: string) {
    const isBaru = type === 'request_baru';
    const formData = isBaru ? this.formDataRequestBaru : this.formDataBateraiRusak;

    const locationName = locationType === 'starting' ? formData.startingLocation : formData.finalLocation;

    const selectedLocation = this.dealerAddress.find(item => item.name === locationName);

    if (!selectedLocation) return;

    if (locationType === 'starting') {
      formData.startingAddress = selectedLocation.address;
    } else if (locationType === 'final') {
      formData.finalAddress = selectedLocation.address;
    }
  }

  onMotorcycleChange(customerIndex?: number) {
    if (typeof customerIndex === 'number' && this.formDataBateraiRusak.suratJalanType === 'permintaan_buka_pintu') {
      const customer = this.formDataBateraiRusak.customers[customerIndex];
      const selected = this.motorcycleList.find(m => m.motorcycle_number === customer.motorcycleNumber);

      if (selected) {
        customer.chassisNumber = selected.chassis_number;
        customer.batteryCode = selected.batteries?.map(b => b.battery_code) || [''];
        this.customerBatteryCodes =
          selected.batteries?.map(b => ({
            label: b.battery_code,
            value: b.battery_code
          })) || [];
      } else {
        customer.chassisNumber = '';
        customer.batteryCode = [''];
        this.customerBatteryCodes = [''];
      }
    } else {
      const selected = this.motorcycleList.find(
        m => m.motorcycle_number === this.formDataBateraiRusak.customer.motorcycleNumber
      );

      if (selected) {
        this.formDataBateraiRusak.customer.chassisNumber = selected.chassis_number;
        this.formDataBateraiRusak.customer.batteryCode = selected.batteries?.map(b => b.battery_code) || [''];
        this.customerBatteryCodes =
          selected.batteries?.map(b => ({
            label: b.battery_code,
            value: b.battery_code
          })) || [];
      } else {
        this.formDataBateraiRusak.customer.chassisNumber = '';
        this.formDataBateraiRusak.customer.batteryCode = [''];
        this.customerBatteryCodes = [''];
      }
    }
  }

  getCombinedBatteryCodes(): string[] {
    // Combine the old battery code and the new battery codes
    const combinedCodes = new Set<string>(this.formDataBateraiRusak.customer.batteryCode);
    if (this.formDataBateraiRusak.customer.oldBatteryCode) {
      combinedCodes.add(this.formDataBateraiRusak.customer.oldBatteryCode);
    }
    return Array.from(combinedCodes);
  }

  customFormValidation() {
    if (this.ticketType === 'baterai_rusak') {
      if (this.formStep === 2 && this.formDataBateraiRusak.suratJalanType === 'return') {
        if (
          !this.formDataBateraiRusak.customer.batteryCode ||
          this.formDataBateraiRusak.customer.batteryCode.length === 0 ||
          this.formDataBateraiRusak.customer.batteryCode.every(code => !code)
        ) {
          Swal.fire('Error', 'Nomor KTP dan Kode Baterai tidak boleh kosong.', 'error');
          return false;
        }
      }

      // Validation for required fields in formDataBateraiRusak
      if (this.formStep === 1 && this.ticketType === 'baterai_rusak') {
        const requiredFields = [
          { field: 'startingLocation', label: 'Lokasi Awal', value: this.formDataBateraiRusak.startingLocation },
          { field: 'startingAddress', label: 'Alamat Awal', value: this.formDataBateraiRusak.startingAddress },
          { field: 'finalLocation', label: 'Lokasi Tujuan', value: this.formDataBateraiRusak.finalLocation },
          { field: 'finalAddress', label: 'Alamat Tujuan', value: this.formDataBateraiRusak.finalAddress },
          { field: 'suratJalanType', label: 'Jenis Surat Jalan', value: this.formDataBateraiRusak.suratJalanType }
        ];

        const emptyFields = requiredFields.filter(item => !item.value || item.value.trim() === '');

        if (emptyFields.length > 0) {
          const fieldLabels = emptyFields.map(item => item.label).join(', ');
          Swal.fire('Error', `Field berikut wajib diisi: ${fieldLabels}`, 'error');
          return false;
        }
      }

      if (
        this.formStep === 1 &&
        this.formDataBateraiRusak.suratJalanType === 'return' &&
        this.formDataBateraiRusak.shippingInformation.type === 'self_delivery'
      ) {
        if (
          !this.formDataBateraiRusak.shippingInformation.shippingNumber ||
          !this.formDataBateraiRusak.shippingInformation.shippingProof
        ) {
          Swal.fire('Error', 'Nomor resi dan bukti pengiriman wajib diisi.', 'error');
          return false;
        }
      }

      if (
        this.formStep === 1 &&
        this.formDataBateraiRusak.suratJalanType === 'pengiriman' &&
        this.formDataBateraiRusak.shippingInformation.type === 'external_courier'
      ) {
        if (
          !this.formDataBateraiRusak.shippingInformation.shippingNumber ||
          !this.formDataBateraiRusak.shippingInformation.shippingProof
        ) {
          Swal.fire('Error', 'Nomor resi dan bukti pengiriman wajib diisi.', 'error');
          return false;
        }
      }

      if (this.formDataBateraiRusak.suratJalanType === 'permintaan_buka_pintu') {
        if (this.formStep === 1) {
          if (this.formDataBateraiRusak.sgb.id === '' || this.formDataBateraiRusak.sgb.name === '') {
            console.log(this.formDataBateraiRusak.sgb);
            Swal.fire('Error', 'SGB wajib dipilih.', 'error');
            return false;
          }

          if (!this.formDataBateraiRusak.dealerPhoneNumber) {
            Swal.fire('Error', 'Nomor telepon dealer wajib diisi.', 'error');
            return false;
          }
        }

        if (this.formStep === 2) {
          if (
            !this.formDataBateraiRusak.customers ||
            this.formDataBateraiRusak.customers.length === 0 ||
            this.formDataBateraiRusak.customers.some(
              customer =>
                !customer.ktp ||
                !customer.phoneNumber ||
                !customer.name ||
                !customer.motorcycleNumber ||
                !customer.chassisNumber ||
                !customer.batteryCode ||
                customer.batteryCode.length === 0 ||
                customer.batteryCode.every(code => !code)
            )
          ) {
            Swal.fire('Error', 'Semua data customer wajib diisi.', 'error');
            return false;
          }
        }
      }

      return true;
    } else {
      if (this.formStep === 1) {
        const requiredFields = [
          { field: 'startingLocation', label: 'Lokasi Awal', value: this.formDataRequestBaru.startingLocation },
          { field: 'startingAddress', label: 'Alamat Awal', value: this.formDataRequestBaru.startingAddress },
          { field: 'finalLocation', label: 'Lokasi Tujuan', value: this.formDataRequestBaru.finalLocation },
          { field: 'finalAddress', label: 'Alamat Tujuan', value: this.formDataRequestBaru.finalAddress },
          { field: 'suratJalanType', label: 'Jenis Surat Jalan', value: this.formDataRequestBaru.suratJalanType }
        ];

        const emptyFields = requiredFields.filter(item => !item.value || item.value.trim() === '');

        if (emptyFields.length > 0) {
          const fieldLabels = emptyFields.map(item => item.label).join(', ');
          Swal.fire('Error', `Field berikut wajib diisi: ${fieldLabels}`, 'error');
          return false;
        }
      }

      if (this.formDataRequestBaru.suratJalanType === 'pengiriman') {
        if (
          this.inputBatteryCodeType === 'manual' &&
          (!this.batteryCodes || this.batteryCodes.length === 0 || this.batteryCodes.every(code => !code))
        ) {
          Swal.fire('Error', 'Kode Baterai tidak boleh kosong.', 'error');
          return false;
        }

        if (this.inputBatteryCodeType === 'excel' && !this.formDataRequestBaru.excelFile) {
          Swal.fire('Error', 'File Excel Kode Baterai harus diunggah.', 'error');
          return false;
        }

        if (!this.formDataRequestBaru.shippingInformation.type) {
          Swal.fire('Error', 'Tipe Pengiriman wajib diisi.', 'error');
          return false;
        }

        if (this.formDataRequestBaru.shippingInformation.type === 'external_courier') {
          if (!this.formDataRequestBaru.shippingInformation.shippingNumber) {
            Swal.fire('Error', 'Nomor resi wajib diisi.', 'error');
            return false;
          }

          if (!this.formDataRequestBaru.shippingInformation.shippingProof) {
            Swal.fire('Error', 'Bukti pengiriman wajib diisi.', 'error');
            return false;
          }
        }
      }

      if (this.formDataRequestBaru.suratJalanType === 'permintaan') {
        if (!this.formDataRequestBaru.requestTotal || this.formDataRequestBaru.requestTotal <= 0) {
          Swal.fire('Error', 'Total permintaan harus diisi.', 'error');
          return false;
        }

        if (!this.formDataRequestBaru.description || this.formDataRequestBaru.description.trim() === '') {
          Swal.fire('Error', 'Keterangan permintaan harus diisi.', 'error');
          return false;
        }
      }

      return true;
    }
  }

  // Method to handle the submit action
  onSubmit(form) {
    this.isLoading = true;

    if (!this.customFormValidation()) {
      this.isLoading = false;
      return;
    }

    if (form.valid) {
      // Prepare the data to be submitted

      const rawData =
        this.ticketType === 'baterai_rusak'
          ? { ...this.formDataBateraiRusak, createdAt: this.today, 
              customers: JSON.stringify(this.formDataBateraiRusak.customers)
           }
          : { ...this.formDataRequestBaru, batteries: this.batteryCodes, inputMode: this.inputBatteryCodeType };

      const formData = this.convertToFormData(rawData);

      // Here you would call your service to submit the data
      this._SuratJalanBateraiRest.submitDraft(this.suratJalanBaterai._id, formData).subscribe({
        next: response => {
          Swal.fire('Success', 'Tiket berhasil disubmit!', 'success');
          this._suratJalanBateraiListComponent.callHookDirectly('init');
          this.isLoading = false;
          this.closeModal(); // Close modal on success
        },
        error: err => {
          const errorMessage = err.response.data.message;

          this.isLoading = false;
          Swal.fire('Error', `Failed to submit ticket: ${errorMessage}`, 'error');
        }
      });
    } else {
      this.isLoading = false;
      Swal.fire('Error', 'Please fill in all required fields.', 'error');
    }
  }
}
